module.exports = __webpack_public_path__ + "static/media/mutasi_mandiri.2938eff0.png";